// extracted by mini-css-extract-plugin
module.exports = {"survey-rating":"survey-styles_survey-rating__MM8H7"};